<template>
  <button class="col align-center" @click="$emit('click')" :class="{'active': active }">
    <i class="material-icons">
      {{icon}}
    </i>
    <div v-if="text">{{text}}</div>
  </button>
</template>

<script>
export default {
  props: ["icon", "text", "active"]
}
</script>

<style lang="less" scoped>
  .active {
    opacity: 1;
    color: white;
  }

  button {
    opacity: .6;
    color: white;

  }

  button:hover {
    opacity: 1;
  }

</style>
